/***
 * 客单价区间分析
 */
import { post, get, postJson, put, postBlob } from '../axios'

//导出数据
export const exportDataOne = p => get(`/customer-analysis/avgPriceAnalysis/export`, p);

// 列表数据
export const getTableData = p => get(`/customer-analysis/avgPriceAnalysis/list`, p);